(function($) {

    $(window).on('load', function() {

    });

    $(window).on('scroll', function () {

    });

    $(window).on('resize', function () {

    });

})( jQuery );